import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Link } from 'core/routing';

import { clientStore } from 'apps/client/app';

import Heading from 'components/Heading';
import Icon from 'components/Icon';
import Button from 'components/Button';
import { TextField } from 'libs/forms/views/fieldTypes/text';

import {
  NameInput,
  CircleWrapper,
  IconStyled,
  By,
  ProjectNameStyled,
  CommitsWrapper,
} from 'apps/project/views/projectName.styles';

export const ProjectName = observer(({ app, formStore, fieldName }) => {
  if (app) {
    const { spacePath } = app;
    const spaceType = spacePath[0] === '+' ? 'initiative' : 'profile';
    const behind = app.forkDistance?.contributionsBehind || 0;
    const ahead = app.forkDistance?.contributionsAhead || 0;

    return (
      <ProjectNameStyled>
        {app && (
          <>
            {app.editing ? (
              <TextField
                fieldStore={formStore.fieldStores.get(fieldName)}
                editComponent={NameInput}
                noValidation
              />
            ) : (
              <>
                {clientStore.atCommunityRoute && (
                  <Link name='home.community.projects'>
                    <Button
                      size='small'
                      text='All Projects'
                      icon='arrow_left'
                      variant='secondary'
                    />
                  </Link>
                )}
                <Heading level={1} size='xlarge' data-test-id='project-name'>
                  {app[fieldName]}
                  <IconStyled
                    name={app.private ? 'locked' : 'website'}
                    size='large'
                  />
                </Heading>
              </>
            )}
            <By>
              {app.isForked && (
                <CircleWrapper>
                  <Icon name='fork' size='medium' />
                </CircleWrapper>
              )}
              {'by'}
              &nbsp;
              <Link name={spaceType} params={{ [spaceType]: spacePath }}>
                {app.spacePath}
              </Link>
              {app.isForked && (
                <>
                  {', forked from'}
                  &nbsp;
                  <Link {...app.forkOf.route}>
                    {app.forkOf.space.spaceType === 'PROFILE' ? '@' : '+'}
                    {app.forkOf.space.content.slug}
                  </Link>
                </>
              )}
            </By>
            {app.isForked && !(behind === 0 && ahead === 0) && (
              <CommitsWrapper>
                <Heading level={6} size='xsmall' weight='regular'>
                  {`${behind} contribution${
                    's' ? behind !== 1 : ''
                  } behind and ${ahead} contribution${
                    's' ? ahead !== 1 : ''
                  } ahead.`}
                </Heading>
              </CommitsWrapper>
            )}
          </>
        )}
      </ProjectNameStyled>
    );
  }
  return null;
});

ProjectName.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.string,
  editing: PropTypes.bool,
  handleChange: PropTypes.func,
};
